import React from "react";
import { Navigate, Route, useLocation } from "react-router-dom";
import ErrorLogin from "./ErrorMonitor/ErrorLogin";
import ErrorDashboard from "./ErrorMonitor/ErrorDashboard";
import '../assets/css/errorMonitor.css'
import { isErrorMonitorAuthed } from "./ErrorMonitor/errorAuth";

const RequireErrorMonitorAuth = ({ children }) => {
  const location = useLocation();
  if (!isErrorMonitorAuthed()) {
    return (
      <Navigate
        to="/error-monitor/login"
        replace
        state={{ from: location.pathname }}
      />
    );
  }
  return children;
};

export const errorRoutes = (
  <>
    <Route path="/error-monitor/login" element={<ErrorLogin />} />
    <Route
      path="/error-monitor/dashboard"
      element={
        <RequireErrorMonitorAuth>
          <ErrorDashboard />
        </RequireErrorMonitorAuth>
      }
    />
  </>
);

export default errorRoutes;

